import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
/** Split a ts_headline snippet into plain/marked segments (pure helper). */
function parseSnippet(snippet) {
    const segments = [];
    let inMark = false;
    for (const part of snippet.split(/(<mark>|<\/mark>)/g)) {
        if (part === '<mark>') {
            inMark = true;
        }
        else if (part === '</mark>') {
            inMark = false;
        }
        else if (part) {
            segments.push({ text: part, marked: inMark });
        }
    }
    return segments;
}
/**
 * Renders a Postgres ts_headline snippet, turning its <mark> tags into
 * highlights without dangerouslySetInnerHTML. React escapes the surrounding
 * text, so report content cannot inject markup. Shared by the studies search
 * dialog and the teleconsultation worklist.
 */
export function HighlightedSnippet({ snippet, className, }) {
    return (_jsx("span", { className: cn('text-muted-foreground text-xs', className), children: parseSnippet(snippet).map((seg, i) => seg.marked ? (
        // react-doctor-disable-next-line react-doctor/no-array-index-as-key -- positional segments parsed from a ts_headline snippet; re-derived each render, no state
        _jsx("mark", { className: "rounded bg-yellow-500/30 px-0.5 text-inherit", children: seg.text }, i)) : (
        // react-doctor-disable-next-line react-doctor/no-array-index-as-key -- positional segments parsed from a ts_headline snippet; re-derived each render, no state
        _jsx("span", { children: seg.text }, i))) }));
}
